import { render } from "./vegas26.vue?vue&type=template&id=67b0a598"
import script from "./vegas26.vue?vue&type=script&lang=js"
export * from "./vegas26.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__